import store from "@/store/store";

export default function (Vue) {
  Vue.directive("focus", {
    // When the bound element is inserted into the DOM...
    inserted: function (el) {
      if (store.FocusDirective)
        // Focus the element
        el.focus();
    },
  });
}
